import { States } from "..";

export function getFranceDisplayMode(states:States){
   return states.displayMode.FranceDisplayMode
}

export function getEuropeDisplayMode(states:States){
    return states.displayMode.EuropeDisplayMode
}

export function getDepartmentDisplayMode(states:States){
    return states.displayMode.DepartmentsDisplayMode
}

export function getEVMCDisplayMode(states:States){
    return states.displayMode.EVMCDisplayMode
}